import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Linkedin, X } from 'lucide-react';

const STORAGE_KEY = 'tcn_linkedin_prompt_dismissed';
const DELAY_MS = 1 * 60 * 1000;
const DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000; // re-prompt 30 days after dismissal

export function LinkedInPrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedAt = Number(localStorage.getItem(STORAGE_KEY));
    if (dismissedAt && Date.now() - dismissedAt < DISMISS_TTL_MS) return;

    const timer = setTimeout(() => setVisible(true), DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  };

  if (!visible) return null;

  return createPortal(
    <div
      className="fixed bottom-6 right-6 z-50 w-80 bg-white rounded-2xl shadow-2xl border border-border p-5 animate-fade-up"
      role="dialog"
      aria-label="Follow The CISO Network on LinkedIn"
    >
      <button
        onClick={dismiss}
        className="absolute top-3 right-3 p-1.5 text-muted-foreground hover:text-foreground transition-colors rounded-lg hover:bg-muted"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl bg-teal flex items-center justify-center shrink-0">
          <Linkedin className="h-5 w-5 text-white" />
        </div>
        <div>
          <p className="font-heading font-bold text-foreground text-sm leading-snug">
            Enjoying the read?
          </p>
          <p className="text-muted-foreground text-xs mt-1 leading-relaxed">
            Follow The CISO Network on LinkedIn to stay across the latest from the network.
          </p>
        </div>
      </div>

      <div className="mt-4">
        <a
          href="https://linkedin.com/company/thecisonetwork"
          target="_blank"
          rel="noopener noreferrer"
          onClick={dismiss}
          className="block w-full bg-teal text-white text-xs font-medium py-2 px-3 rounded-lg text-center hover:bg-teal/90 transition-colors"
        >
          Follow on LinkedIn
        </a>
      </div>
    </div>,
    document.body
  );
}
